import {
  KnifeActionName,
  KnifeActionTypes,
} from '~src/types/actions/knife-actions'
import knifeMakerDefaultState from '~src/store/preloaded-state'
import { KnivesSet } from '~src/types/types-store'

const knivesSetReducer = (
  state = knifeMakerDefaultState.knivesSet,
  action: KnifeActionTypes
): KnivesSet => {
  switch (action.type) {
    case KnifeActionName.SET_KNIVES:
      return {
        ...state,
        pickedKnives: action.pickedKnives,
      }
    case KnifeActionName.SET_MATERIAL:
      return {
        ...state,
        configuration: {
          ...state.configuration,
          [action.payload.knifePart]: action.payload.material,
        },
      }
    default:
      return state
  }
}

export { knivesSetReducer }
